import DOMPurify from "dompurify"
import "../assets/css/sanitized-description.css"

const SanitizedDescription = ({ desc, id, custCls }) => {
  const cleanHTML = DOMPurify.sanitize(desc)
  
  return <div id={id} className={`font-agcasmlt ${custCls}`} dangerouslySetInnerHTML={{ __html: cleanHTML }}></div >
}

export default SanitizedDescription;